import { Zap } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useGetApiCompaniesCurrentEmployeesReportingDoneactionmodules } from '@/api/generated/company-management-user/company-management-user'
import { StatisticsCard } from '../components/StatisticsCard'

export function TopActionsCard() {
  const { t } = useTranslation('dashboard')
  const { data, isLoading, isError } = useGetApiCompaniesCurrentEmployeesReportingDoneactionmodules({ take: 1 })

  const top = data?.data?.[0]

  return (
    <StatisticsCard
      title={t('statistics.topActions.title')}
      value={top?.totalDoneActionModules ?? '—'}
      sub={top ? [top.firstName, top.lastName].filter(Boolean).join(' ') : undefined}
      CustomIcon={Zap}
      isLoading={isLoading}
      isError={isError}
    />
  )
}
